(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    // ==========================================================================
    // SmoothScroll
    // ==========================================================================
    function setupSmoothScroll() {
      const header = document.getElementById("js-header");
      const offsetHeaderH = header ? header.offsetHeight : 0;
      const offset = window.innerWidth < 768 ? offsetHeaderH : 100;

      // SmoothScrollインスタンスを作成（返却してあとで破棄可能にする）
      const scroll = new SmoothScroll('a[href*="#"]', {
        updateURL: false,
        offset: offset,
        speed: 100,
        speedAsDuration: true,
      });

      return {
        destroy: () => {
          // イベント解除
          scroll.destroy();
        },
      };
    }

    const scrollController = setupSmoothScroll();
    // scrollController.destroy();

    // END
  });
})();
